import React from 'react'
import { useAppDispatch } from '../../../hooks/redux'

import { updateUserSettings } from '../../../lib/api'
import { useEnvironment } from '../../../providers/EnvironmentProvider'
import { AddErrorAlert, AddSuccessAlert } from '../../../slices/alert'

import SettingsSaveButton from '@SonarCX/components/atoms/SettingsSaveButton'
import SettingsPage from '../SettingsPage'
import ChannelSettings from './ChannelsSettings'
import IncomingMessagesSettings from './IncomingMessagesSettings'
import NoPermissionContainer from '../../../components/molecules/NoPermissionContainer'

const OPTIONS = {
  n_client_sound_new_msg: 'Play sound for incoming Conversation messages',
  n_peer_sound_new_msg: 'Play sound for incoming Peer Chat messages',
  n_peer_push:
    'Use full push notifications for Peer Chats if the browser window is closed'
}
const SETTING_KEY = 'n_enabled_channels'

const NotificationSettings = () => {
  const dispatch = useAppDispatch()
  const {
    loaded: envLoaded,
    user,
    update: updateUser,
    error: envError,
    reload
  } = useEnvironment()
  const [error, setError] = React.useState(null)
  const [saving, setSaving] = React.useState(false)
  const [channelValues, setChannelValues] = React.useState([])
  const [values, setValues] = React.useState(
    Object.keys(OPTIONS).reduce((prev, curr) => {
      prev[curr] = true
      return prev
    }, {})
  )

  const handleSave = React.useCallback(async () => {
    try {
      setSaving(true)
      const oldSettings = user.settings.reduce((prev, curr) => {
        prev[curr.key] = curr.value
        return prev
      }, {})
      const newSettings = Object.entries(
        Object.assign({ ...oldSettings }, values)
      ).map(([key, value]) => ({
        key,
        value: String(value)
      }))
      let channelSettings
      const enabledChannels = channelValues
        .filter(val => val.checked === true)
        .map(val => val.id)
      if (enabledChannels.length === 0 && channelValues.length > 0) {
        channelSettings = ''
      } else {
        channelSettings = enabledChannels
      }
      const filteredSettings = newSettings.filter(
        setting => setting.key !== SETTING_KEY
      )
      const allSettings = [
        ...filteredSettings,
        {
          key: SETTING_KEY,
          value: channelSettings === '' ? '' : channelSettings.join(',')
        }
      ]
      const response = await updateUserSettings(user.id, { items: allSettings })
      updateUser({ ...user, settings: response })
      reload()
      dispatch(AddSuccessAlert('Changes saved'))
      setSaving(false)
    } catch (err) {
      console.error('Error while updating user', err)
      setError({ err })
      dispatch(AddErrorAlert({ err }))
      setSaving(false)
    }
  }, [channelValues, updateUser, user, values, dispatch, reload])

  return (
    <NoPermissionContainer skipAgentPage error={error || envError}>
      <SettingsPage title='Notifications'>
        <IncomingMessagesSettings
          values={values}
          setValues={setValues}
          envLoaded={envLoaded}
          user={user}
          options={OPTIONS}
        />

        <ChannelSettings
          values={channelValues}
          setValues={setChannelValues}
          envLoaded={envLoaded}
          user={user}
        />

        <SettingsSaveButton onClick={handleSave} loading={saving} />
      </SettingsPage>
    </NoPermissionContainer>
  )
}

export default NotificationSettings
